module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-link"
  }, [_c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Tags")]), _vm._v(" "), _c('div', [(_vm.productTags.length < 1) ? _c('div', [_vm._v("\n            This product has no tags\n            "), _c('br')]) : _vm._e(), _vm._v(" "), _vm._l((_vm.productTags), function(tag) {
    return _c('div', [_c('router-link', {
      attrs: {
        "to": {
          name: 'tag',
          params: {
            id: tag.id
          }
        }
      }
    }, [_vm._v("\n                " + _vm._s(tag.name) + "\n            ")]), _vm._v(" "), _c('a', {
      staticClass: "delete",
      on: {
        "click": function($event) {
          return _vm.remove(tag)
        }
      }
    })], 1)
  })], 2), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.adding) ? _c('div', [_c('a', {
    staticClass: "button is-small",
    on: {
      "click": function($event) {
        _vm.adding = true
      }
    }
  }, [_vm._v("Add tag...")])]) : _vm._e(), _vm._v(" "), (_vm.adding) ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    attrs: {
      "name": "tag-add"
    },
    on: {
      "change": function($event) {
        return _vm.add($event.target.value)
      }
    }
  }, [_c('option', [_vm._v("Select a tag...")]), _vm._v(" "), _vm._l((_vm.availableTags), function(tag) {
    return _c('option', {
      domProps: {
        "value": tag.id
      }
    }, [_vm._v(_vm._s(tag.name))])
  })], 2)]), _vm._v(" "), _c('button', {
    staticClass: "button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.adding = false
      }
    }
  }, [_vm._v("Cancel")])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-738af824"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/components/products/ProductTags.vue
// module id = 553
// module chunks = 0